// Downloads the Quaternius character files and the animation source.
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { P } from '../../lib/factory.js';
import { splashProgress } from '../../ui/splash.js';

export let mixers, idlers, bobbers, wading, P_, animSrc, models, clip, H, FINGERS;

export async function loadCharacterModels() {
  const CHAR_FILES = [
    'modular_men_Casual',
    'modular_men_Casual2',
    'modular_men_Suit',
    'modular_men_Worker',
    'modular_men_Adventurer',
    'modular_women_Casual',
    'modular_women_Suit',
    'modular_women_Worker',
    'modular_women_Adventurer',
  ];
  mixers = [];
  idlers = [];
  bobbers = [];
  wading = [];
  P_ = P; // material helper; inside the loader P names a prepared character
  const loader = new GLTFLoader();
  let loaded = 0;
  const load = (f) =>
    loader.loadAsync('assets/characters/' + f + '.glb').then((r) => {
      splashProgress(0.4 + (0.5 * ++loaded) / (CHAR_FILES.length + 1));
      return r;
    });

  [animSrc, ...models] = await Promise.all([
    load('cyberpunk_Character_anims'),
    ...CHAR_FILES.map(load),
  ]);
  clip = (name) => animSrc.animations.find((a) => a.name.endsWith('|' + name));
  H = 0.92;
  FINGERS = /^(Index|Middle|Ring|Pinky|Thumb)/;
}
